import { customElement, property } from 'lit/decorators.js';
import { html, css, nothing } from 'lit';
import { BaseComponent } from '../../base-component/base-component';
import '../product-card-display/product-card-image.display';
import '../product-card-display/product-card-metadata.display';
import { ProductCardData } from '../product-card-display';
import { booleanConverter } from '../../../common/converters';
import { getProductUrl, goToProductPage } from '../utils/product-card.util';
import { connect } from 'pwa-helpers';
import store from '../../../store/store';
import { CtaTypeLabel } from '../product.interface';
import { getImageSrcUrl } from '../../../common/utils/product-util';
import { emitProductAnalyticsEvent } from '../utils/product-card.analytics.util';
import { SEG_LOWER } from '../../../common/utils/util';

@customElement('mhecomm-k12-program-card-display')
export class K12ProgramCardDisplay extends connect(store)(BaseComponent) {
  @property({ type: Object })
  product?: ProductCardData;

  @property({ converter: booleanConverter })
  showBusinessUnitLabel = false;

  @property({ converter: booleanConverter })
  showBusinessLabelType = true;

  @property({ converter: booleanConverter })
  showCopyright = false;

  @property({ converter: booleanConverter })
  showDescription = true;

  @property({ converter: booleanConverter })
  showGrades = true;

  @property()
  businessLabelText = 'PreK-12';

  @property()
  businessLabelType = 'Program';

  @property()
  cta = CtaTypeLabel.NO_CTA;

  @property()
  orientation = 'vertical';

  @property({ type: String })
  headingLevel = "h3";

  static styles = [
    css`
      .uxt-mhcorp {
        height: 100%;
      }
    `,
  ];

  renderComp() {
    return this.product
      ? html` <div class="product-card ${this.orientation} align-items-center rounded text-left shadow border-0 h-100 d-flex position-relative whole-card-clickable focus-within">
          <mhecomm-product-card-image-display productTitle="${this.product?.title}" productImageUrl="${getImageSrcUrl(this.product?.image!)}"> </mhecomm-product-card-image-display>
          <div class="product-card-contents p-3 lh-base d-flex flex-column h-100">
            <mhecomm-product-card-metadata-display
              .product="${this.product}"
              businessLabelText="${this.businessLabelText}"
              businessLabelType=${this.businessLabelType}
              ?wholecardclickable=${true}
              .titleTabbable=${this.cta === CtaTypeLabel.NO_CTA}
              ?showBusinessUnitLabel=${this.showBusinessUnitLabel}
              ?showBusinessLabelType=${this.showBusinessLabelType}
              ?showDescription=${this.showDescription}
              ?showGrades=${this.showGrades}
              ?showCopyright=${this.showCopyright}
              titleHref="${getProductUrl(this.product)}"
              .titleClickListener=${(e: Event) => {
                e.preventDefault();
                const target = e.currentTarget as HTMLAnchorElement;
                emitProductAnalyticsEvent(this, this.product!, SEG_LOWER, 'mhecomm-k12-program-cards');
                window.location.href = target.href;
              }}
              headingLevel="${this.headingLevel}"
            >
            </mhecomm-product-card-metadata-display>
            ${this.cta !== CtaTypeLabel.NO_CTA ? this.generateProductCardCta(this.product) : nothing}
          </div>
        </div>`
      : nothing;
  }

  generateProductCardCta(product) {
    return html`<div class="product-card-cta-container pt-3 w-100">
      <button
        class="product-card-view-button btn btn-primary w-100 stretched-link"
        aria-label="View Program ${product.title}"
        @click="${() => {
          emitProductAnalyticsEvent(this, product, SEG_LOWER, 'mhecomm-k12-program-cards');
          goToProductPage(product);
        }}"
      >
        View Program
      </button>
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-k12-program-card-display': K12ProgramCardDisplay;
  }
}